import { Controller } from 'stimulus';

export default class PanelEditableDropdownController extends Controller {
  static targets = ['input'];
  static values = { url: String };

  connect() {
    this._ensureUrlValue();
    this._initDropdown();
    this.cleanUpMenu();
  }

  _ensureUrlValue() {
    if (!this.urlValue) {
      throw new Error(
        'panel--editable-dropdown: you must provide a url-value (full path)!',
      );
    }
  }

  _initDropdown() {
    this.$dropdown = $(this.element).dropdown({
      action: 'nothing',
      onChange: () => this.removeCheckmarks(),
    });
  }

  get menuItems() {
    return Array.from(this.element.querySelectorAll('.menu .item'));
  }

  get acceptItem() {
    return this.element.querySelector('.menu .item.accept');
  }

  select(event) {
    event.stopPropagation();
    const item = event.currentTarget;
    const value = item.dataset.value;

    this.inputTarget.value = value;
    this._activateItem(item);
    this._appendCheckmark(item);
    this.acceptItem?.classList.add('enabled');
  }

  accept(event) {
    event.stopPropagation();
    const selected = this.inputTarget.value;
    const paramName = this.inputTarget.name;
    // Allow empty string (which represents nil/None option) to be submitted
    // Only prevent submission if selected is null or undefined
    if (selected == null) return;

    this.$dropdown.dropdown('hide');
    this._submitSelection(this.urlValue, paramName, selected);
  }

  _activateItem(item) {
    this.menuItems.forEach((i) => i.classList.remove('active'));
    item.classList.add('active');
    this.removeCheckmarks();
  }

  _appendCheckmark(item) {
    item.insertAdjacentHTML(
      'beforeend',
      '<i class="check icon selected-checkmark"></i>',
    );
  }

  async _submitSelection(fullPath, paramName, value) {
    const token = document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute('content');
    const payload = { [paramName]: value };

    try {
      const resp = await fetch(fullPath, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': token,
          'Content-Type': 'application/json',
          Accept: 'text/vnd.turbo-stream.html',
        },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) {
        throw new Error(`Network error (status ${resp.status})`);
      }

      const html = await resp.text();
      Turbo.renderStreamMessage(html);
      this.cleanUpMenu();
    } catch (err) {
      console.error(`Error sending ${paramName} to ${fullPath}:`, err);
    }
  }

  removeCheckmarks() {
    this.element
      .querySelectorAll('.selected-checkmark')
      .forEach((el) => el.remove());
  }

  cleanUpMenu() {
    this.removeCheckmarks();
    this.acceptItem?.classList.remove('enabled');
  }
}
